import React from 'react';
import JavascriptReferencesObjects from './JavascriptReferencesObjects.jsx';
import JavascriptReferencesHtmlDomObjects from './JavascriptReferencesHtmlDomObjects.jsx';

export default function JsReferences() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS References</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/references/objects' className='underline'>JavaScript Objects</a></li>
<li><a href='/javascript/references/html-dom-objects' className='underline'>HTML DOM Objects</a></li>
      </ul>
    </div>
  );
}
